module.exports = __webpack_public_path__ + "static/img/9areaB_07.5325860.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/9areaB_07.png
// module id = 1239
// module chunks = 1